import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import { SelectFiltersFormModalComponent } from '@shared/components';
import { CustomFormComponent } from '@services/formBuilder/abstract-custom-form-field';

import { assign, compact, map, orderBy } from 'lodash';
import { TranslateService } from '@ngx-translate/core';

export interface FilterPopupConfig {
  title?: string;
  subTitle?: string;
  saveButton?: string;
}

@Component({
  selector: 'app-select-filters-form',
  templateUrl: './select-filters-form.component.html',
  styleUrls: ['./select-filters-form.component.scss'],
})
export class SelectFiltersFormComponent extends CustomFormComponent implements OnInit {
  public popupConfig: FilterPopupConfig;
  public btnTitle: string = this.translate.instant('SHARED.Add_Filters');
  public options: any[];
  public reportID: string;
  public selectedItems: any[];
  public optsList: any[];
  public filters: any[];

  constructor(private popoverController: PopoverController, private translate: TranslateService) {
    super();
  }

  ngOnInit() {
    // CVX-6547: a field may give a shorter list name plus a description line; the list still sorts on the full title
    this.optsList = map(this.options, (item) => ({
      id: item.name,
      name: item.filterName ?? item.title,
      description: item.filterDescription ?? '',
      sortKey: item.title
    }));

    this.selectedItems = compact(this.selectedItems);
  }

  public showDataToIncludeForm(): void {
    const config: Record<string, any> = {
      options: orderBy(this.optsList, 'sortKey'),
      selectedItems: this.selectedItems,
    };

    if (this.popupConfig) {
      assign(config, this.popupConfig);
    }

    this.popoverController.create(<any>{
      component: SelectFiltersFormModalComponent,
      animated: false,
      componentProps: config
    }).then((element: HTMLIonPopoverElement) => {
      element.present();

      element.onDidDismiss().then((event) => {
        if (event.data && event.data !== this.selectedItems) {
          this.formValue = event.data;
        }
      });
    });
  }

}
